import Div from '@/shared/Div';
import React, { PropsWithChildren, memo } from 'react';
import classNames from 'classnames';
import Map from '../Map';
import Image from '@/shared/Image';
import { parseMediaFromCMS } from '@/utils/image';
import is from '@/utils/is';

interface BenefitItem {
  icon: any;
  text: string;
}

interface ServiceBenefitItems {
  list: BenefitItem[];
}

export interface ServiceBenefitProps extends ServiceBenefitItems {
  dataTestId?: string;
  title?: string;
}

function ServiceBenefit(props: PropsWithChildren<ServiceBenefitProps>) {
  const { list, title = 'Service benefits', dataTestId } = props;
  if (is.empty.array(list)) return null;
  return (
    <Div dataTestId={dataTestId} className="mt-s9 md:mt-s10">
      <Div className="text-h-3 lg:text-hd-3 overflow-hidden truncate text-black mb-s5">{title}</Div>
      <Map
        className="py-5 px-4 border border-solid border-[#CEA44F] rounded-cs bg-gradient-to-b from-[#FDF4E2] to-FFF"
        list={list}
        wrapper="div"
        render={({ icon, text }, index) => {
          let islastItem = index == list?.length - 1;
          return (
            <Div
              key={index}
              className={classNames('flex gap-s4', {
                'pt-s5 lg:pt-5': index !== 0,
              })}
            >
              {icon && icon.data ? (
                <Div className="w-7">
                  <Image
                    width={25}
                    height={25}
                    src={parseMediaFromCMS(icon).src}
                    alt=""
                    loading="lazy"
                  />
                </Div>
              ) : null}
              <Div
                className={classNames(
                  'w-full text-h-4 lg:text-hd-4 border-b border-solid border-extended-gold border-opacity-40 text-cm-primary',
                  {
                    'pb-s5 lg:pb-5': !islastItem,
                    'border-none': islastItem,
                  },
                )}
              >
                {text}
              </Div>
            </Div>
          );
        }}
      />
    </Div>
  );
}
export default memo(ServiceBenefit);
